import React, { useState, useCallback, useEffect } from "react";
import {
    ComboBox,
    IComboBox,
    IComboBoxOption,
    Text,
} from "@fluentui/react";
import _ from "lodash";
import { getCompanies, getCompany } from "../../../../../connectors/clients/connectors/index";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { IconButton, IMessageBarStyles, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { useField } from "formik";
import { optionsS } from "../../../styles/clientsDropDown.styles";
import { titleS } from "../../../styles/detailTxt.style";

const errorMessageS: IMessageBarStyles = {
    root: {
        marginTop: "15px",
        width: "100%",
    },
};

interface ClientsDropDownProps {
    value: string;
    label: string,
    name: string,
    setFieldValue?: any;
    resetForm?: any;
    onChange?: any;
    required?: boolean,
    setDepartments?: any,
    company?: any;
}

const ClientsDropDown: React.FC<ClientsDropDownProps> = ({
    setFieldValue,
    resetForm,
    value,
    onChange,
    label,
    name,
    required,
    company
}) => {
    const [clients, setClients] = useState<any>([]);
    const [inputValue, setInputValue] = useState("");
    const [asyncActionInProgress, setAsyncActionInProgress] = useState<boolean>(false);
    const [field, { error }] = useField(name);
    const comboBoxRef = React.useRef<IComboBox>(null);

    const openMenu = React.useCallback(() => {
        if (comboBoxRef.current != undefined) {
            comboBoxRef.current.focus(true)
        }
    }, []);
    
    const handleChange = useCallback(
        (option?: IComboBoxOption, index?: number, value?: string): void => {
            if (value !== undefined) {
                // if (value.length > 5) {
                //     openMenu();
                // }
                setInputValue(value);
            }
        },
        []
    );

    useEffect(() => {
        fetchClients();
    }, []);

    useEffect(() => {
        fetchClient()
    },[company])

    const fetchClient = async () =>{
        if(company && company.key != ""){
            const found = clients.find((x :any)=> x.key == company.key);
            if(found == undefined){
                const res = await getCompany(company.key);
                const companyResponse = res.data.data;
                var data = [
                    {
                    key: companyResponse.basicInformations.id,
                    text: (companyResponse.basicInformations.shortName && companyResponse.basicInformations.shortName !== "" ? companyResponse.basicInformations.shortName : companyResponse.basicInformations.companyName) + ' (' + companyResponse.basicInformations.taxNumber + ')',
                    data: companyResponse.basicInformations
                }]
                setClients(data)
                onChange(data[0])
                setFieldValue(name, data[0]);
            }
            else
            {
                setClients([found])
                onChange(found)
                setFieldValue(name, found);
            }
        }
    }

    const fetchClients = async (currentInputValue?: string) => {
        setAsyncActionInProgress(true);

        const searchPhrase = currentInputValue !== undefined ? currentInputValue : inputValue;
        const params = {
            page: 1,
            limit: 20,
            Verified: true,
            IsActive: true,
            ...(searchPhrase && { searchPhrase }),
            searchFields: ["companyName", "shortName", "taxNumber"],
            searchMode: "advanced"
        };
        const res = await getCompanies(params);
        const data = res.data.data.map((client: any) => {
            return {
                key: client.id,
                text: (client.shortName && client.shortName !== "" ? client.shortName : client.companyName) + ' (' + client.taxNumber + ')',
                data: client,
            };
        });

        setClients(data);
        if(currentInputValue  && currentInputValue !== ""){
            openMenu();
        }
        setAsyncActionInProgress(false);
    }

    const setOption = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption,
        index?: number,
        value?: string
    ): void => {
        if (option) {
            resetForm();
            setFieldValue(name, option);
            if (onChange) {
                onChange(option)
            }
        }
    };

    return <div>
        <ComboBox
            componentRef={comboBoxRef}
            required={required ? required : false}

            disabled={asyncActionInProgress}
            selectedKey={value}
            autoComplete={"on"}
            allowFreeform
            onPendingValueChanged={handleChange}
            onKeyDownCapture={(e:any) => {
                if (e.key && e.key === 'Enter') {
                    e.preventDefault();
                    fetchClients(inputValue);
                }
            }}
            onRenderLabel = {()=>{
                return <div>
                    <Text styles={titleS}>{label}</Text>
                    {asyncActionInProgress ?
                        <Spinner size={SpinnerSize.small} />:
                        <IconButton
                            text=""
                            primary
                            style={{
                                marginLeft: 10,
                                height: 24,
                                width: 24
                            }}
                            iconProps={{
                            iconName: 'Search',
                            styles : { root: {height: 16, width: 16}}

                            } }
                            disabled={asyncActionInProgress}
                                onClick={(e) => {
                                e.preventDefault();
                                fetchClients(inputValue);
                                }}
                            />
                    }
                </div>}}
            onChange={setOption}
            options={clients}
            dropdownWidth={550}
            styles={optionsS}
        />
        {error && (
            <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}
                dismissButtonAriaLabel="Close"
                styles={errorMessageS}>
                {error}
            </MessageBar>
        )}
    </div>
};

export default ClientsDropDown;